import "../scss/custom.scss";
import Fingerprint2 from "fingerprintjs2";

/******************
 User custom JS
 ---------------

 Put JS-functions for your template here.
 If possible use a closure, or add them to the general Template Object "Template"
 */

// Selectors for PLZ and Town Questions
const plzInputQuestion = "#question2";
const townSelectQuestion = "#question3";
const agsInputQuestion = "#question27";
const clientInfoQuestion = "#question23";

const ajaxPath = "/upload/themes/survey/vanilla_fkt2020/files/ajax.php";

$(document).on('ready pjax:scriptcomplete',function(){
    /**
     * Code included inside this will only run once the page Document Object Model (DOM) is ready for JavaScript code to execute
     * @see https://learn.jquery.com/using-jquery-core/document-ready/
     */

    $(plzInputQuestion+' input').keyup(onInputChanged);
    const townSelect =$('<select></select>')
    townSelect.addClass('form-control');
    townSelect.addClass('list-question-select')
    townSelect.append($('<option></option>').attr('value', '').text("Bitte auswählen"));
    $(townSelectQuestion+' input[type=text]').hide().parent().append(townSelect);
    $(townSelectQuestion+' select').change(onTownSelected);

    $.getJSON(ajaxPath+"?q="+$(plzInputQuestion+' input').val(),requestReturn);

    $(clientInfoQuestion).hide();
    $(agsInputQuestion).hide();

    if (window.requestIdleCallback) {
        requestIdleCallback(function () {
            Fingerprint2.get(onFingerprintingDone);
        })
    } else {
        setTimeout(function () {
            Fingerprint2.get(onFingerprintingDone);
        }, 500)
    }
});

/**
 * Plz to town lookup
 */
// callback from the plz field
function onInputChanged(event){
    $.getJSON(ajaxPath+"?q="+this.value,requestReturn);
}

// callback from the ajax request
function requestReturn(data){
    const townSelect = $(townSelectQuestion+' select');
    townSelect.empty();
    if (data.length === 0) {
        townSelect.prepend(
            $('<option></option>').attr('value', '').text("Bitte auswählen")
        );
    } else {
        const options = [];
        for (var i = 0; i < data.length; i++) {
            const value = data[i][0];
            const title = data[i][1];
            const ags = data[i][2];
            const option = $('<option></option>');
            option.attr('value', value);
            option.data('ags', ags);
            option.attr('data-ags',ags);
            option.text(title);
            options.push(option);
        }
        townSelect.append.apply(townSelect, options);
    }
    townSelect.val(townSelect.find('option').first().attr('value'));
    setTimeout(function(){townSelect.change();},1);
}

function onTownSelected(event) {
    const townSelect = $(townSelectQuestion+' select');
    const townInput = $(townSelectQuestion+' input[type=text]');
    const selectedOption = townSelect.find('option[value="'+townSelect.val()+'"]');
    $(agsInputQuestion+' input').val(selectedOption.data('ags'));
    townInput.val(townSelect.val());
    townInput.change();
}

function onFingerprintingDone(components) {
    const output = {};
    components.forEach(function (component) {
        output[component.key] = component.value;
    });
    $(clientInfoQuestion + ' textarea').val(JSON.stringify(output));
}

/*** EXPORTS FROM exports-loader ***/
